import React from "react"
import { useNavigate } from "react-router-dom"
import backarrow from "../../Assets/Icons/back-arrow.png"

function LabelHeader({
  text, //string
  //   link, //string
}) {
  const navigateto = useNavigate()
  return (
    <div className="row header-back">
      <div className="col-1 text-center mt-2">
        <img
          src={backarrow}
          alt="back"
          className="backarrow back-arrow-new-class"
          width={25}
          height={25}
          onClick={() => navigateto(-1)}
        ></img>
      </div>
      <div className="col font-big font-bold heading-title-new">{text}</div>
    </div>
  )
}

export default LabelHeader
